import React, { useContext, useState } from "react";
import Button from "../common/Button";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

import { ReactComponent as ArrowRightSvg } from "../../assets/icons/arrow-right.svg";
import { ReactComponent as ArrowRightDisabledSvg } from "../../assets/icons/arrow-right-disabled.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/icons/arrow-left.svg";
import { ReactComponent as FileUploaderPlaceholderSvg } from "../../assets/icons/fileuploader-placeholder.svg";
import { ReactComponent as TrashSvg } from "../../assets/icons/trash.svg";

import NewProjectContext from "../../contexts/NewProjectContext";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Scrollbar, Mousewheel } from "swiper/modules";

const UploadPanoramas = (props) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.project);
  const TranslationCommon = getLang(langComponent.common);
  const { goForward, goBackward, details, setDetails } =
    useContext(NewProjectContext);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState(details?.panoramaImages || []);

  const handleFiles = (files) => {
    if (files.length === 0) return;

    setFiles((curr) => {
      // * Filter out duplicate files
      const existingFilenames = curr.map((c) => c.name);

      const _files = [...files].filter(
        (file) => !existingFilenames.includes(file.name)
      );

      return [...curr, ..._files];
    });
  };

  const handleRemoveImage = (file) => {
    setFiles((curr) => [...curr.filter((f) => f.name !== file.name)]);
  };

  const handleDragDropEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if ((e.type === "dragenter" || e.type === "dragover") && !dragActive) {
      setDragActive(true);
    }

    if ((e.type === "dragleave" || e.type === "drop") && dragActive) {
      setDragActive(false);
    }

    if (e.type === "drop") {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleContinue = () => {
    if (files.length === 0) return;
    setDetails((curr) => ({ ...curr, panoramaImages: files }));
    goForward();
  };

  return (
    <div className="new-project-image-upload">
      <h1 className="new-project__heading1">Upload panorama images</h1>
      <div
        className={`new-project-image-upload-fileuploader ${
          dragActive ? "new-project-image-upload-fileuploader--highlight" : ""
        }`}
        onDragEnter={handleDragDropEvents}
        onDragOver={handleDragDropEvents}
        onDragLeave={handleDragDropEvents}
        onDrop={handleDragDropEvents}
      >
        <FileUploaderPlaceholderSvg />
        <p className="new-project-image-upload-fileuploader__info">
          {Translation("Drop your images here or")}{" "}
          <label
            className="new-project-image-upload-fileuploader__input-trigger"
            htmlFor="new-project-image-upload-fileuploader__input"
          >
            {Translation("browse")}
          </label>
          <br />
          {Translation("Supports: JPG and PNG")}
        </p>
        <input
          id="new-project-image-upload-fileuploader__input"
          type="file"
          multiple
          accept="image/*"
          onClick={(e) => {
            e.target.value = null;
          }}
          onChange={(e) => handleFiles(e.target.files)}
        />
      </div>
      <Swiper
        direction={"horizontal"}
        slidesPerView={"auto"}
        freeMode={true}
        modules={[FreeMode, Scrollbar]}
        className="new-project-image-upload-gallery"
      >
        {[...files].map((file) => {
          const _src = URL.createObjectURL(file);
          return (
            <SwiperSlide
              key={file.name}
              className="new-project-image-upload-gallery-image"
            >
              <img
                className="new-project-image-upload-gallery-image__preview"
                alt="preview_image"
                src={_src}
              />
              <TrashSvg
                className="new-project-image-upload-gallery-image__trash"
                onClick={() => handleRemoveImage(file)}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="new-project-image-upload-footer">
        <Button
          label={TranslationCommon("Return")}
          variant={"secondary"}
          leadingIcon={<ArrowLeftSvg />}
          onClick={() => goBackward()}
        />
        <Button
          label={TranslationCommon("Continue")}
          trailingIcon={
            files.length > 0 ? <ArrowRightSvg /> : <ArrowRightDisabledSvg />
          }
          disabled={files.length === 0}
          onClick={handleContinue}
        />
      </div>
    </div>
  );
};

UploadPanoramas.propTypes = {};

export default UploadPanoramas;
